import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { OrderSummaryBody } from './components/OrderSummaryBody';
import { OrderSummaryTotal } from './components/OrderSummaryTotal';
export const OrderSummary = ({ isCompact, items, locale, }) => {
    if (isCompact) {
        return _jsx(OrderSummaryTotal, { isCompact: true, items: items, locale: locale });
    }
    return (_jsxs(_Fragment, { children: [_jsx(OrderSummaryBody, { items: items, locale: locale }), _jsx(OrderSummaryTotal, { items: items, locale: locale })] }));
};
//# sourceMappingURL=OrderSummary.js.map